import axios from 'axios';
import axiosInstance from '../../../_utils/axiosConfig';

let Transaction : any = {};

Transaction.getDepenses = async (id:any) =>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/transaction/depense/${id}`)
}
Transaction.getAllTransaction = async (id:any)=>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/get/all/transaction/${id}`)
}

Transaction.getVentes = async (id:any) =>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/transaction/vente/${id}`)
}

Transaction.getService = async()=>{
     return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/all/service`);
}

Transaction.storeFournisseur = async (data:any)=>{
    return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/transaction/fournisseur/store`,data)
}

Transaction.getFournisseur = async()=>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/all/fournisseur`)
}

Transaction.storeCustomer = async (data:any)=>{
    return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/transaction/customer/store`,data);
}

Transaction.getCustomer = async()=>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/all/customer`)
}

Transaction.getDepenseByUser = async(id:any)=>{
    return await axiosInstance.get(`${process.env.REACT_APP_BASE_URL}/api/transaction/depense-customer/${id}`)
}

Transaction.Submit = async (data:any)=>{
   return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/store/transaction`,data);
}

Transaction.UpdateTransaction = async (data:any)=>{
   return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/update/transaction`,data)
}

Transaction.DeleteTransaction = async (idTrans:any,id:any)=>{
   return await axios.delete(`${process.env.REACT_APP_BASE_URL}/api/delete/transaction/${idTrans}/${id}`)
}

export default Transaction;